export default {
  Settings: 'SETTINGS',
  Import: 'IMPORT',
  Shortcuts: 'SHORTCUTS',
  Selector: 'SELECTOR',
  Splash: 'SPLASH',
}



// WEBPACK FOOTER //
// ./src/components/ModalTypes.jsx